import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import AppHeader from "../appHeader/appHeader";
import AppMenu from "../appMenu/appMenu";
import AppAdmin from "../appMenu/appAdmin";
import AppFooter from "../appFooter/appFooter";
import AppSetting from "../appSetting/appSetting";

/**
 * Este componente exibe os contatos de suporte organizados por departamento.
 * Realiza a autenticação do usuário e exibe as informações dos contatos de forma estruturada.
 */
function Suporte() {
    // Estados para gerenciar autenticação e dados do usuário
    const [authenticated, setAuthenticated] = useState(false);
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    /**
     * Efeito para autenticar o usuário ao montar o componente.
     * Redireciona para a página de login se a autenticação falhar.
     */
    useEffect(() => {
        axios
            .post("/api/auth", { withCredentials: true })
            .then((response) => {
                if (response.data.status === 200) {
                    setAuthenticated(true);
                    setUser(response.data.user);
                } else {
                    window.location.href = "/login";
                }
            })
            .catch(() => {
                window.location.href = "/login";
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    /**
     * Dados dos contatos organizados por departamento.
     * Facilita a renderização dinâmica dos cartões de contato.
     */
    const contatos = [
        {
            departamento: "Departamento Trabalhista",
            nome: "Arthur Sanches",
            sobre: "Sócio / Advogado Gestor da Trabalhista",
            endereco: "Endereço: ...",
            telefone: "(14) 99788-8112",
            imagem: "../../dist/img/arthur.png",
        },
        {
            departamento: "Departamento Empresarial",
            nome: "Carlos Eduardo Ribeiro Pugliezi",
            sobre: "Advogado Empresarial",
            endereco: "Endereço: Marechal Rondon, 101, AP 103",
            telefone: "(18) 99729-8468",
            imagem: "../../dist/img/cadu.png",
        },
        {
            departamento: "Departamento de Tecnologia",
            nome: "Jonathan Novaes",
            sobre: "Desenvolvedor Full Stack",
            endereco:
                "Endereço: Reverendo João Batista Ribeiro Neto, 30, PQ. Universitário",
            telefone: "(18) 99689-1342",
            imagem: "../../dist/img/johnny.jpg",
        },
    ];

    // Estilos para o spinner de carregamento
    const spinnerStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
    };

    /**
     * Renderiza o spinner de carregamento enquanto a autenticação está em progresso.
     */
    if (isLoading) {
        return (
            <div style={spinnerStyle}>
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    /**
     * Renderiza a interface de suporte apenas para usuários autenticados.
     */
    if (authenticated) {
        return (
            <>

                {/* Cabeçalho da Página */}
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Contatos</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item">
                                        <a href="/">Início</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Contatos
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Conteúdo Principal */}
                <section className="content">
                    <div className="card card-solid">
                        <div className="card-body pb-0">
                            <div className="row">
                                {contatos.map((contato, index) => (
                                    <div
                                        key={index}
                                        className="col-12 col-sm-6 col-md-4 d-flex align-items-stretch flex-column"
                                    >
                                        <div className="card bg-light d-flex flex-fill">
                                            <div className="card-header text-muted border-bottom-0">
                                                {contato.departamento}
                                            </div>
                                            <div className="card-body pt-0">
                                                <div className="row">
                                                    <div className="col-7">
                                                        <h2 className="lead">
                                                            <b>
                                                                {contato.nome}
                                                            </b>
                                                        </h2>
                                                        <p className="text-muted text-sm">
                                                            <b>Sobre:</b>{" "}
                                                            {contato.sobre}
                                                        </p>
                                                        <ul className="ml-4 mb-0 fa-ul text-muted">
                                                            <li className="small">
                                                                <span className="fa-li">
                                                                    <i className="fas fa-lg fa-building" />
                                                                </span>
                                                                {
                                                                    contato.endereco
                                                                }
                                                            </li>
                                                            <li className="small">
                                                                <span className="fa-li">
                                                                    <i className="fas fa-lg fa-phone" />
                                                                </span>
                                                                Telefone:{" "}
                                                                {
                                                                    contato.telefone
                                                                }
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-5 text-center">
                                                        <img
                                                            src={contato.imagem}
                                                            alt={`Avatar de ${contato.nome}`}
                                                            className="img-circle img-fluid"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-footer">
                                                <div className="text-right">
                                                    {/* Espaço para futuras funcionalidades */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="card-footer text-center">
                            <div className="row">
                                <div
                                    className="col"
                                    style={{ color: "#869099" }}
                                >
                                    <strong>SUPORTE AN</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }

    // Caso o usuário não esteja autenticado, redireciona para a página de login
    return null;
}

export default Suporte;
